import { handleResponse } from 'helper/handleResponse';
import { authHeader } from 'helper/authHeader';
import { baseUrl } from 'helper/ApiCall';

export const testimonialService = {
    getTestimonials,
    storeTestimonial,
    // deleteTestimonial,
    showTestimonial,
    editTestimonial,
    updateTestimonialStatus,
    approveByToken
}

// function getTestimonials(brand_id, pageSize, sort, filter, is_admin) {
//     return SC.getCall(`testimonial?brand=${brand_id}&pageSize=${pageSize}&sort=${sort}&filter=${filter}&is_admin=${is_admin}`);
// }
function getTestimonials(brand_id, page, pageSize, sort, filter, is_admin){
    const requestOptions = {
        method  : 'GET',
        headers : authHeader()
    };
    return fetch(baseUrl+`testimonial?brand=${brand_id}&page=${page}&pageSize=${pageSize}&sort=${sort}&filter=${filter}&is_admin=${is_admin}`, requestOptions).then(handleResponse);
}

// function storeTestimonial(data) {
//     return SC.postCallWithoutAuth('testimonial', data);
// }

function storeTestimonial(data){

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(baseUrl+'testimonial', requestOptions)
        .then(handleResponse)
        .then(testimonial => {
            return testimonial;
        });
}

// function deleteTestimonial(id) {
//     return SC.deleteCall(`deleteTestimonial/${id}`)
// }
// function showTestimonial(id) {
//     return SC.getCall(`testimonial/${id}`)
// }

function showTestimonial(id){

	const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };



    return fetch(baseUrl+'testimonial/'+id, requestOptions).then(handleResponse);
}
// function editTestimonial(id, data) {
//     return SC.putCall(`testimonial/${id}`, data);
// }

function editTestimonial(id, data){
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(baseUrl+'testimonial/'+id, requestOptions)
            .then(handleResponse)
            .then(testimonial => {
                return testimonial;
            })
}
function updateTestimonialStatus(id, data){
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(baseUrl+'updateTestimonialStatus/'+id, requestOptions)
            .then(handleResponse)
            .then(testimonial => {
                return testimonial;
            })
}
function approveByToken(token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
        // No body needed here!
    };

    return fetch(baseUrl + 'testimonial/approve/' + token, requestOptions)
        .then(handleResponse)
        .then(testimonial => {
            return testimonial;
        });
}


// WEBPACK FOOTER //
// ./src/services/testimonials.js